
import { Prop, Vue, Component } from 'vue-property-decorator';

@Component
export default class BaseButton extends Vue {

    @Prop({ required: true }) readonly styledType!: 'big' | 'small' | 'full';
    @Prop({ required: true }) readonly text!: string;
    @Prop({ default: false }) readonly disabled!: boolean;

    onClick(event: Event): void {
        this.$emit('click', event);
    }
}
